import axios from "axios";

export const state = {
    specialisation: [],
};

export const getters = {
    specialisation: state => state.specialisation,
};

export const mutations = {
    setSpecialisation(state, newValue) {
        state.specialisation = newValue
    },
};

export const actions = {
    fetchSpecialisation({ commit }) {
        axios.get('/specialisation').then(res => {
            commit('setSpecialisation', res.data.specialisation)
        })
    },
};
